export const ONR_SwitchTestsAndInspectionsReportSections = {
  monthly: {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    minDataRowsCount: 2,
    columns: [
      {
        title: "Monthly Tests",
        colSpan: 20,
        rowSpan: 1,
        className: "tbl-text-normal",
        columns: [
          {
            title: "Test Description & Rule",
            colSpan: 7,
            rowSpan: 1,
            className: "tbl-text-normal",
            accessor: "testDescription",
            dataClassName: "text-left pd-left-10px d-block",
          },
          {
            title: "Condition Left",
            colSpan: 3,
            rowSpan: 1,
            className: "tbl-text-normal",
            accessor: "summary.test",
          },
          {
            title: "Comments",
            colSpan: 10,
            rowSpan: 1,
            className: "tbl-text-normal",
            dataClassName: "text-left pd-left-10px d-block",
            accessor: "summary.com",
          },
        ],
      },
    ],
  },
  quarterly: {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    minDataRowsCount: 3,
    columns: [
      {
        title: "Quarterly Tests",
        colSpan: 24,
        rowSpan: 1,
        className: "tbl-text-normal",
        columns: [
          {
            title: "Test Description & Rule",
            colSpan: 4,
            rowSpan: 1,
            className: "tbl-text-normal",
            accessor: "testDescription",
            dataClassName: "text-left pd-left-10px d-block",
          },
          {
            title: "Condition Left",
            colSpan: 4,
            rowSpan: 1,
            className: "tbl-text-normal",
            accessor: "summary.test",
          },
          {
            title: "Record Charge Voltage (VAC)",
            colSpan: 4,
            rowSpan: 1,
            className: "tbl-text-normal",
            accessor: "summary.rcvolt",
          },
          {
            title: "Record Discharge Voltage (VDC)",
            colSpan: 4,
            rowSpan: 1,
            className: "tbl-text-normal",
            accessor: "summary.rdvolt",
          },
          {
            title: "AC Power Restored",
            colSpan: 4,
            rowSpan: 1,
            className: "tbl-text-normal",
            accessor: "summary.acprest",
          },
          {
            title: "Comments",
            colSpan: 4,
            rowSpan: 1,
            className: "tbl-text-normal",
            dataClassName: "text-left pd-left-10px d-block",
            accessor: "summary.com",
          },
        ],
      },
    ],
  },

  semiAnnual: {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    minDataRowsCount: 3,
    columns: [
      {
        title: "Semi-Annual Tests",
        colSpan: 21,
        rowSpan: 1,
        className: "tbl-text-normal",
        columns: [
          {
            title: "Test Description & Rule",
            colSpan: 3,
            rowSpan: 1,
            className: "tbl-text-normal",
            accessor: "testDescription",
            dataClassName: "text-left pd-left-10px d-block",
          },
          {
            title: "Condition Left",
            colSpan: 3,
            rowSpan: 1,
            className: "tbl-text-normal",
            accessor: "summary.test",
          },
          {
            title: "NORM Throw Peak Current (A)",
            colSpan: 3,
            rowSpan: 1,
            className: "tbl-text-normal",
            accessor: "summary.ntpcurr",
          },
          {
            title: "REV Throw Peak Current (A)",
            colSpan: 3,
            rowSpan: 1,
            className: "tbl-text-normal",
            accessor: "summary.rtpcurr",
          },
          {
            title: "AVG Throw Time NORM (s)",
            colSpan: 3,
            rowSpan: 1,
            className: "tbl-text-normal",
            accessor: "summary.avgttnorm",
          },
          {
            title: "AVG Throw Time REV (s)",
            colSpan: 3,
            rowSpan: 1,
            className: "tbl-text-normal",
            accessor: "summary.avgttrev",
          },
          {
            title: "Comments",
            colSpan: 3,
            rowSpan: 1,
            className: "tbl-text-normal",
            dataClassName: "text-left pd-left-10px d-block",
            accessor: "summary.com",
          },
        ],
      },
    ],
  },

  annual: {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    minDataRowsCount: 2,
    columns: [
      {
        title: "Annual Tests",
        colSpan: 20,
        rowSpan: 1,
        className: "tbl-text-normal",
        columns: [
          {
            title: "Test Description & Rule",
            colSpan: 7,
            rowSpan: 1,
            className: "tbl-text-normal",
            accessor: "testDescription",
            dataClassName: "text-left pd-left-10px d-block",
          },
          {
            title: "Condition Left",
            colSpan: 3,
            rowSpan: 1,
            className: "tbl-text-normal",
            accessor: "summary.test",
          },
          {
            title: "Comments",
            colSpan: 10,
            rowSpan: 1,
            className: "tbl-text-normal",
            dataClassName: "text-left pd-left-10px d-block",
            accessor: "summary.com",
          },
        ],
      },
    ],
  },
};



// WEBPACK FOOTER //
// ./src/components/Reports/ONR/SwitchTestsAndInspectionsReport/ONR_SwitchTestsAndInspectionsReportSchema.js